module.exports = __webpack_public_path__ + "img/col2.3f344969.svg";